import React from 'react';
import T from 'prop-types';
import { ThemeProvider } from 'styled-components';

import { Container } from './style';

const PlanIcon = ({ type }) => (
  <ThemeProvider theme={{ type }}>
    <Container />
  </ThemeProvider>
);

PlanIcon.propTypes = {
  type: T.string.isRequired,
};

export default PlanIcon;
